import request from '../utils/request';

export function logout(data) {
    return request({
        url: '/admin/logout',
        method: 'post',
        data
    });
}

export function changePassword(data) {
    return request({
        url: '/admin/edit_pass',
        method: 'post',
        data
    });
}

export function editName(data) {
    return request({
        url: '/admin/edit_name',
        method: 'post',
        data
    });
}
